
export enum TechSubCategoryTitle {
    ALL = "All",
    TECHNICAL_SKILLS = "Technical Skills",
    EDUCATION = "Education",
    WORK_EXPERIENCE = "Work Experience",
    CERTIFICATION = "Certification",
    PROJECTS = "Projects"
}